/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2504
 */

var r = require(/* 998 */"./2502/998/index")
module.exports = function (e) {
  return r(this, e).get(e)
}
